import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { verifyVendor } from "./api";
import { useLocation } from "react-router-dom";
import MrqFormTable from "./MrqFormTable";
import moment from "moment";
import PortalHeader from "../../Components/PortalHeader";
import { InfoCard } from "../../Components/InfoCard";
import DownloadablePage from "../../../../components/DownloadablePage";
import EditIcon from "@mui/icons-material/Edit";

export default function VendorMrqForm() {
  const [data, setData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      await verifyVendor(location.pathname.split("/")[2])
        .then((response) => {
          setData(response);
          console.log("Data---------------", data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    verifyToken();
  }, []);

  // const cols = [
  //   { id: "id", label: "", minWidth: 20, align: "center" },
  //   { id: "description", label: "Material Description", minWidth: 200 },
  //   { id: "qty", label: "Quantity", minWidth: 100, align: "center" },
  //   { id: "time", label: "Time (in Days)", minWidth: 120, align: "left" },
  //   {
  //     id: "cost",
  //     label: "Cost / Unit (in Dollar$)",
  //     minWidth: 120,
  //     align: "left",
  //   },
  // ];

  // const { onChange, onSubmit, values, setValues } = useForm(
  //   putVendorMrqCallback,
  //   data.materials
  // );

  // async function putVendorMrqCallback() {
  //   console.log("first");
  // }

  const mrqData = {
    "MRQ Number": data?.mrqNumber,
    "MRQ Revision": data?.rev,
    Company: data?.companyName,
    "Issued At": moment(data?.createdAt).format("YYYY-MM-DD"),
  };

  return (
    <DownloadablePage fileName={data?.mrqNumber + "_Rev-" + data.rev + ".pdf"}>
      <Box sx={{ p: 4 }}>
        <PortalHeader
          logo="/image/chinook_blue-logo-only.png"
          title={
            data?.mrqNumber ? data?.mrqNumber + " / Rev: " + data?.rev : ""
          }
          date={data?.createdAt}
        />
        {/* Cards Section */}
        <Grid container spacing={3} mb={4}>
          <Grid item xs={12} md={6}>
            <InfoCard title="MRQ Details" data={mrqData} />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "inline-block",
            textAlign: "left",
          }}
        >
          {data ? (
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  MRQ Materials
                  <Typography
                    sx={{
                      float: "right",
                      color: "#999",
                      fontSize: "12px",
                      pt: 1.5,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    *Update (Time + Cost + Data Sheet) for each material.
                    <EditIcon sx={{ width: "12px", ml: 0.5 }} />
                  </Typography>
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <MrqFormTable data={data ? data : []} />
              </CardContent>
            </Card>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </DownloadablePage>
  );
}
